import { CustomSelect } from 'components/Toolkit/Inputs/CustomSelect';
import { ListSkeleton } from 'features/location/components/ListSkeleton/ListSkeleton';

import type { SearchInputAndPrimarySelectProps } from 'features/location/components/SearchInputAndPrimarySelect/SearchInputAndPrimarySelect.typed';
import { useLocationContext } from 'features/location/Location.context';
import { LEVELS } from 'features/location/Location.typed';
import { useLocation } from 'features/location/Location.hook';

import * as Styled from 'features/location/components/SearchInputAndPrimarySelect/SearchInputAndPrimarySelect.styled';

function SearchInputAndPrimarySelect(props: SearchInputAndPrimarySelectProps) {
  const {
    skeletonListLength,
    autoFocus,
    isLocationBottomSheetOpen,
    isExpanded,
  } = props;

  const {
    searchInput,
    areas,
    isLoading,
    level,
    selectedCounty,
    setIsLoading,
    setAutocompleteOptions,
    setCountyAreas,
    countyAreaSelect,
    levelOneReset,
    levelTwoReset,
    handleClose,
    setAreas,
    locationDisplay,
    countyTown,
    countyList,
  } = useLocationContext();

  const { handleSelectListItem } = useLocation({
    isLocationBottomSheetOpen,
    isExpanded,
    selectedCounty,
    setIsLoading,
    setAutocompleteOptions,
    setCountyAreas,
    countyAreaSelect,
    levelOneReset,
    levelTwoReset,
    handleClose,
    setAreas,
    searchInput,
    level,
    locationDisplay,
    countyTown,
    countyList,
  });

  return (
    <Styled.Container>
      {/* Render element based on "open" state to ensure autofocus is applied, 
      rather than applying it to an element rendered but not in view 
      which removes autofocus from that element on open */}
      {(isExpanded || isLocationBottomSheetOpen) && (
        <>
          <Styled.SSearchInput autoFocus={autoFocus} />
          {isLoading && <ListSkeleton arrayLength={skeletonListLength} />}
          {!isLoading && areas.length !== 0 && (
            <CustomSelect
              onSelect={handleSelectListItem}
              listData={areas}
              displayIcon={level === LEVELS.LEVEL_ONE}
              hasHeading={searchInput.length < 3}
            />
          )}
        </>
      )}
    </Styled.Container>
  );
}

export { SearchInputAndPrimarySelect };
